import slice from 'store/features/projectData/slice'
import { TAppDispatch } from 'store/types'
import { IMediaItem } from 'types/media'
import {
  addToLocalStorageProcessingItems,
  removeFromLocalStorageProcessingItems
} from 'utils/localStorage'

const { actions } = slice

const saveProcessingItemData =
  (mediaItem: IMediaItem) => (dispatch: TAppDispatch) => {
    dispatch(actions.addProcessingItems([mediaItem]))
    addToLocalStorageProcessingItems(mediaItem)
  }

const removeFromProcessingItems = (id: string) => (dispatch: TAppDispatch) => {
  dispatch(actions.removeProcessingItems([id]))
  removeFromLocalStorageProcessingItems([id])
}

export const projectDataProcessingItemsThunks = {
  saveProcessingItemData,
  removeFromProcessingItems
}
